import { BadRequestError, useEventsConfigurationService } from 'nekst-api';
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useSettingsNavigator from "../settingsNavigator";

export default function useCodeHandler() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const eventConfigurationService = useEventsConfigurationService();

  const hasCode = !!code;

  const settingsNavigator = useSettingsNavigator();

  useEffect(() => {
    async function createAccessTokens() {
      try {
        if (code) {
          await eventConfigurationService.createTokens({ code });
          settingsNavigator.openCalendarIntegrationPage();
        }
      } catch (e) {
        if (e instanceof BadRequestError) {
          settingsNavigator.openCalendarIntegrationPage(e.response.code);
        } else {
          throw e;
        }
      }

    }
    createAccessTokens();
  }, []);

  return {
    hasCode,
    code,
  };
}
